class DigitalPayPaymentErrorDisplayService {
    constructor($timeout, moveFocus, settings, digitalPayPaymentErrorStateService, digitalPayErrorMessageGenerator) {
        this.$timeout = $timeout;
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.digitalPayPaymentErrorStateService = digitalPayPaymentErrorStateService;
        this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
        this.clearGlobalError();
    }

    pushGlobalError(errorMessage = undefined) {
        const isSplitPayment = this.digitalPayErrorMessageGenerator.getPaymentErrorMode();
        if (!errorMessage) {
            errorMessage = isSplitPayment
                ? this.settings.digitalPayError.genericGlobalSplitPaymentMessage
                : this.settings.digitalPayError.genericGlobalPaymentMessage;
        }
        this.setGlobalBannerError(errorMessage);
    }

    /**
     * Push an error in response to a validation failure produced by wallet
     * @param {string} errorMessage
     */
    pushToPaymentErrorBreakdown(errorMessage) {
        this.paymentErrors.push(errorMessage);
    }

    getGlobalErrorMessage(showRawErrorMessage = false) {
        const isSplitPayment = this.digitalPayErrorMessageGenerator.getPaymentErrorMode();
        if (!showRawErrorMessage && this.paymentErrors && this.paymentErrors.length) {
            if (this.paymentErrors.length === 1 && !isSplitPayment) {
                // When there is exactly one error in the list and we're not doing split payments, show that error by itself without a header error message
                return '';
            }
            return this.settings.digitalPayError.multipleGlobalPaymentErrorMessage;
        }

        return this.globalErrorMessage;
    }

    getPaymentErrors() {
        return this.paymentErrors;
    }

    clearGlobalError() {
        this.globalErrorMessage = undefined;
        this.paymentErrors = [];
        this.digitalPayPaymentErrorStateService.clearErrors();
    }

    setGlobalBannerError(errorMessage) {
        this.globalErrorMessage = errorMessage;
        this.moveFocus('.digitalPayErrorDisplay-errorMessage');
    }
}

module.exports = DigitalPayPaymentErrorDisplayService;



// WEBPACK FOOTER //
// ./src/wallet/error/digital-pay-payment-error-display.service.js